// ** Reactstrap Imports
import { Edit2, MoreVertical, Trash2, File, Copy } from 'react-feather';
import {
  Badge,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  UncontrolledDropdown
} from 'reactstrap';

// ** Renders Role Columns
const renderType = (row) => {
  const typeColor = {
    video: {
      primary: '#14E4ED',
      secondary: '#E8FEFF',
      text: 'Video'
    },
    audio: {
      primary: '#EB36B4',
      secondary: '#FFEBF9',
      text: 'Audio'
    },
    friends: {
      primary: '#EDC314',
      secondary: '#FFF8E8',
      text: 'Amigos'
    },
    form: {
      primary: '#7139F0',
      secondary: '#EFE8FF',
      text: 'Formulario'
    },
    checklist: {
      primary: '#3945f0',
      secondary: '#e3e5ff',
      text: 'CheckList'
    }
  };

  const Div = () => (
    <div
      style={{
        color: typeColor[row.type].primary,
        background: `${typeColor[row.type].secondary
          } 0% 0% no-repeat padding-box`,
        padding: '2.5px 16px',
        borderRadius: '11px',
        fontWeight: 'bold'
      }}
    >
      {typeColor[row.type].text}
    </div>
  );

  return (
    <span className="text-left">
      <Div />
    </span>
  );
};

const statusObj = {
  active: 'light-success',
  inactive: 'light-secondary'
};

export const columns = ({ handleDelete, navigate, duplicateActivity }) => [
  {
    name: 'NOMBRE DE LA ACTIVIDAD',
    sortable: true,
    minWidth: '300px',
    sortField: 'name',
    selector: (row) => row.name,
    cell: (row) => (
      <div className="d-flex justify-content-left align-items-center">
        <div className="d-flex flex-column">
          {/* <Link
            to={`/users/view/${row._id}`}
            className="user_name text-truncate text-body"
            onClick={() => {
              // store.dispatch(getUser(row._id))
            }}
          >
          </Link> */}
          <span className="fw-bolder">{row.name}</span>
        </div>
      </div>
    )
  },
  {
    name: 'TIPO',
    sortable: true,
    minWidth: '172px',
    sortField: 'role',
    selector: (row) => row.type,
    cell: (row) => renderType(row)
  },
  {
    name: 'EMPEZADOS',
    minWidth: '138px',
    sortable: true,
    sortField: 'started',
    selector: (row) => row.currentPlan,
    cell: (row) => <span className="text-capitalize">{row.started}</span>
  },
  {
    name: 'PORCENTAJE',
    minWidth: '230px',
    sortable: false,
    sortField: '',
    selector: (row) => row.billing,
    cell: (row) => (
      <div className="progress" style={{ width: '100%', height: 7 }}>
        <div
          id={row._id}
          className="progress-bar"
          role="progressbar"
          style={{
            background: '#4DFF84',
            width: row.started ? `${(row.finished / row.started) * 100}%` : '0%'
          }}
          aria-valuenow={row.started || 0}
          aria-valuemin={0}
          aria-valuemax={100}
        ></div>
      </div>
    )
  },
  {
    name: 'COMPLETADOS',
    minWidth: '138px',
    sortable: true,
    sortField: 'finished',
    selector: (row) => row.currentPlan,
    cell: (row) => <span className="text-capitalize">{row.finished}</span>
  },
  {
    name: 'Estado',
    minWidth: '138px',
    sortable: true,
    sortField: 'status',
    selector: (row) => row.status,
    cell: (row) => (
      <Badge
        className="text-capitalize"
        color={row.status ? statusObj.active : statusObj.inactive}
        pill
      >
        {row.status ? 'Activo' : row.draf ? 'Borrador' : 'Inactivo'}
      </Badge>
    )
  },
  {
    name: '',
    minWidth: '100px',
    cell: (row) => (
      <div className="column-action">
        <UncontrolledDropdown>
          <DropdownToggle tag="div" className="btn btn-sm">
            <MoreVertical size={14} className="cursor-pointer" />
          </DropdownToggle>
          <DropdownMenu>
            <DropdownItem
              tag="a"
              href="/"
              className="w-100"
              onClick={(e) => {
                e.preventDefault();
                navigate(`/roads/activities/response/${row._id}`);
              }}
            >
              <File size={14} className="me-50" />
              <span className="align-middle">Respuestas</span>
            </DropdownItem>
            <DropdownItem
              tag="a"
              href="/"
              className="w-100"
              onClick={(e) => {
                e.preventDefault();
                navigate(`/roads/activities/edit/${row._id}`);
              }}
            >
              <Edit2 size={14} className="me-50" />
              <span className="align-middle">Editar</span>
            </DropdownItem>
            <DropdownItem
              tag="a"
              href="/"
              className="w-100"
              onClick={(e) => handleDelete(e, row._id)}
            >
              <Trash2 size={14} className="me-50" />
              <span className="align-middle">Eliminar</span>
            </DropdownItem>
            <DropdownItem
              tag="button"
              className="w-100"
              onClick={() => duplicateActivity(row)}
            >
              <Copy size={14} className="me-50" />
              <span className="align-middle">Duplicar</span>
            </DropdownItem>

          </DropdownMenu>
        </UncontrolledDropdown>
      </div>
    )
  }
];
